export default __webpack_public_path__ + "static/media/driveability_yellow.b016e1b3.svg";